/**
 * Locale storage management
 * Syncs locale between localStorage and cookies
 */

export const localeStorage = {
  /**
   * Save locale to localStorage and cookie
   */
  set(locale: string): void {
    localStorage.setItem("locale", locale);
    // Mirror to cookie so middleware can pick it up server-side
    document.cookie = `locale=${locale}; path=/; max-age=${60 * 60 * 24 * 365}; SameSite=Lax`;
  },

  /**
   * Get locale from localStorage
   */
  get(): string | null {
    return localStorage.getItem("locale");
  },

  /**
   * Remove locale from localStorage and cookies
   */
  remove(): void {
    localStorage.removeItem("locale");
    document.cookie = "locale=; path=/; max-age=0; SameSite=Lax";
  },
};
